angular.module('mercury.modules.stock.positemlink')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.PosItemLink', {
    url: '/positemlinks',
    templateUrl: 'modules/stock/positemlink/positemlink.tpl.html',
    controller: 'StockPositemlinkCtrl'
  });

  $stateProvider.state('Stock.PosItemLink.Linked', {
    url: '/linked/:groupName',
    templateUrl: 'modules/stock/positemlink/edit.tpl.html',
    controller: 'StockPositemlinkEditCtrl',
    data: {
      menuLinkState: 'Stock.PosItemLink'
    }
  });

  $stateProvider.state('Stock.PosItemLink.Unlinked', {
    url: '/unlinked/:groupName',
    templateUrl: 'modules/stock/positemlink/edit.tpl.html',
    controller: 'StockPositemlinkEditCtrl',
    data: {
      menuLinkState: 'Stock.PosItemLink'
    }
  });

  $stateProvider.state('Stock.PosItemLink.Suggestions', {
    url: '/suggestions',
    templateUrl: 'modules/stock/positemlink/suggestions.tpl.html',
    controller: 'StockPositemlinkSuggestionsCtrl',
    data: {
      menuLinkState: 'Stock.PosItemLink'
    }
  });
}]);
